/* tslint:disable:forin */
import { Component, OnInit, Input, Output, EventEmitter, DoCheck, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
// Importing the locations json file so that we can make use of it
import { SharedFunctions } from 'src/app/shared/functions/shared-functions';
import { SharedServices } from 'src/app/services/shared-services';
import { SearchDataStorageService } from 'src/app/services/search-datastorage.services';
import { Messages } from 'src/app/shared/constants/project-messages';
import { projectConstants } from 'src/app/shared/constants/project-constants';
// Importing the locations json file so that we can make use of it
 import  locationjson from '../../../../assets/json/locations.json';
import   metrojson from '../../../../assets/json/metros_capital.json';
import { SearchFields } from './searchfields';
import { CommonfilterService } from '../../../services/commonfilter.service';
// import { projectConstants } from '../../constants/project-constants';
export class Locscls {
  constructor(public autoname: string, public name: string,
     public lat: string, public lon: string, public typ: string, public rank: number) { }
}
export class Keywordsgroupcls {
  constructor(public displayname: string, public name: string) { }
}

export class Keywordscls {
  constructor(public autoname: string, public name: string, public domain: string, public subdomain: string,
     public typ: string,     public claimable: string , public title: string) { }
}
@Component({
  selector: 'app-aws-search',
  templateUrl: './aws-search.component.html',
  styleUrls: ['./aws-search.component.css']
})
export class AwsSearchComponent implements OnInit, OnChanges, DoCheck  {


  all_cap = Messages.ALL_CAP;
  more_options_cap = Messages.MORE_OPTIONS_CAP;
  public searchfields: SearchFields = new SearchFields();
  @Input() showopennow: number;
  @Input() domainpassedfromrefined: string;
  @Input() subdomainpassedfromrefined: any;
  @Input() domainlistpassed: any = [];
  @Input() includedfrom: any;
  @Input() passedDomain: string;
  @Input() title: string;
  @Input() passedkwdet: any = [];
  @Input() passedRefine: any = [];
  @Output() searchclick = new EventEmitter<any>();

  myControl_prov: UntypedFormControl = new UntypedFormControl();
  myControl_loc: UntypedFormControl = new UntypedFormControl();
  myControl_domain: UntypedFormControl = new UntypedFormControl();
  myControl_claimable: UntypedFormControl = new UntypedFormControl();

  public domainlist_data;
  public location_exists: boolean;
  public location_data;
  public nocriteria: boolean;
  public loading = false;
  public subscription;
  public searchlabels_dataholder;
  public searchlabels_data;

  public location_name;
  public sortfield;
  public sortorder;
  public hide_location_div: boolean;

  public kw_autoname;

  public prov_subscription;
  public provider_data;
  public suggestions = [];
  public prolocation_exists: boolean;
  public prov_loading = false;
  public prov_nocriteria: boolean;
  public hide_prov_div: boolean;
  public prov_id;
  public prov_name;
  public search_string: string;
  public selected_domain;
  public selected_claimable;
  public acc_name;
  public popular_search;
  public opennow_search;
  public searchlabel_search;
  public show_searchlabellist;
  public commonfilters;
  public insidelocloop;
  showMoreOptionsOverlay = false;
  curlabel = { typ: '', query: '' };

  moreoptions_arr: any = [];
  location_arr: any = [];
  state_arr: any = [];
  statename_arr: any = [];
  city_arr: any = [];
  cityname_arr: any = [];
  area_arr: any = [];
  areaname_arr: any = [];

  locationList: Locscls[] = [];
  displaylocationList: Locscls[] = [];
  locsearchcriteria = '';

  keywordList: Keywordscls[] = [];
  displaykeywordList: Keywordscls[] = [];
  keyssearchcriteria = '';

  subdomainList: Keywordscls[] = [];
  holdisplaylist: Keywordscls[] = [];
  specilizationList: Keywordscls[] = [];
  titleobj: Keywordscls[] = [];

  keywordgroupList: Keywordsgroupcls[] = [];

  locationholder: Locscls;
  keywordholder: Keywordscls;
  showmoreoptionsSec = false;
  holdsrchlocname = '';
  @ViewChild('locrefrence', {static: false}) private locRef: ElementRef;
  @ViewChild('provbox', { read: MatAutocompleteTrigger, static: false }) provRef: MatAutocompleteTrigger;
  moreoptionsTooltip = '';
  configData: any = {};
  claimedStatus: any;
  claimable_selected: string;
  acc_selected: string;

  constructor(
    private shared_service: SharedServices,
    private shared_functions: SharedFunctions,
    private searchdataserviceobj: SearchDataStorageService,
    private dialog: MatDialog,
    private routerobj: Router,
    private route: ActivatedRoute,
    private commonService: CommonfilterService) {

    this.myControl_prov.valueChanges.subscribe(val => {
      this.filterKeywords(val);
    });
    this.myControl_loc.valueChanges.subscribe(val => {
      this.filterLocation(val);
    });
    this.commonService.getConfigData()
    .subscribe(res => {
      this.configData = res;
      this.claimedStatus = this.configData.claimedStatus;

    });
  }

  ngOnInit() {
    // console.log('srch pass kw', this.passedkwdet);
    // console.log('Refined search ', this.passedRefine);
    // this.moreoptionsTooltip = this.shared_functions.getProjectMesssages('MOREOPTIONS_TOOLTIP');
    if (this.passedkwdet.kwtyp === 'label') {
      if (this.passedkwdet.kwdomain !== '' && this.passedkwdet.kwdomain !== undefined) {
        this.curlabel.typ = 'label';
        this.curlabel.query = this.passedkwdet.kwdomain;
      }
    }
    // console.log('included from', this.includedfrom);
    this.selected_domain = 'All';
    if (this.passedDomain) {
      this.selected_domain = this.passedDomain;
    }
    this.selected_claimable = 'All';
    this.acc_name = this.title;
    // console.log(this.acc_name);
    if (this.domainlistpassed.length > 0) {
      // console.log('reached exists');
      this.domainlist_data = this.domainlistpassed;
      // this.loadkeywordAPIreponsetoArray();
    } else {
      // console.log('reached not exists');
      this.getDomainList();
    }
   // this.getAllsearchlabels();
    this.setNulllocationvalues('');
    this.setNullKeyword('');
    this.hide_location_div = false;
    this.initialize_fields();
    this.loadLocationjsontoArray();
    // Checking whether the location is blank, if yes, then set it to the default location mentioned in the constants file
    this.checktoSetLocationtoDefaultLocation();

  }
  checktoSetLocationtoDefaultLocation() {
    // console.log('loccheck search', this.locationholder);
    if (this.locationholder.autoname === '' || this.locationholder.autoname === undefined || this.locationholder.autoname === null) {
      /* if the location details are saved in the local storage, fetch them and set it as the location */

      const localloc = this.shared_functions.getitemfromLocalStorage('ynw-locdet');
      if (localloc) {
        if (localloc.autoname !== '' && localloc.autoname !== undefined && localloc.autoname !== null) {
          this.locationholder = localloc;
          this.location_name = localloc.autoname;
        } else { // case if details are not there in the local storage
          this.location_name = projectConstants.SEARCH_DEFAULT_LOCATION.autoname;
          this.locationholder.autoname = this.location_name;
          this.locationholder.name = projectConstants.SEARCH_DEFAULT_LOCATION.name;
          this.locationholder.lat = projectConstants.SEARCH_DEFAULT_LOCATION.lat;
          this.locationholder.lon = projectConstants.SEARCH_DEFAULT_LOCATION.lon;
          this.locationholder.typ = projectConstants.SEARCH_DEFAULT_LOCATION.typ;
          this.shared_functions.setitemonLocalStorage('ynw-locdet', this.locationholder);
        }
      } else {
        this.location_name = projectConstants.SEARCH_DEFAULT_LOCATION.autoname;
        this.locationholder.autoname = this.location_name;
        this.locationholder.name = projectConstants.SEARCH_DEFAULT_LOCATION.name;
        this.locationholder.lat = projectConstants.SEARCH_DEFAULT_LOCATION.lat;
        this.locationholder.lon = projectConstants.SEARCH_DEFAULT_LOCATION.lon;
        this.locationholder.typ = projectConstants.SEARCH_DEFAULT_LOCATION.typ;
        this.shared_functions.setitemonLocalStorage('ynw-locdet', this.locationholder);
      }

    }
  }
  ngDoCheck() {
    // console.log('ondocheck');
    // this.initialize_fields();
    // if (this.searchfields.domain !== this.selected_domain) {
    //   this.selected_domain = this.searchfields.domain;
    // }
    // if (this.searchfields.kw !== this.keywordholder.name) {
    //   this.kw_autoname = this.searchfields.kwautoname;
    //   this.keywordholder.autoname = this.searchfields.kwautoname;
    //   this.keywordholder.name = this.searchfields.kw;
    //   this.keywordholder.domain = this.searchfields.kwdomain;
    //   this.keywordholder.subdomain = this.searchfields.kwsubdomain;
    //   this.keywordholder.typ = this.searchfields.kwtyp;
    // }
    // if (this.searchfields.sortfield) {
    //   this.sortfield = this.searchfields.sortfield;
    // }
    // if (this.searchfields.sortorder) {
    //   this.sortorder = this.searchfields.sortorder;
    // }
  }
  ngOnChanges() {
    if (this.domainpassedfromrefined) {
      this.selected_domain = this.domainpassedfromrefined;
    }
    if (this.subdomainpassedfromrefined) {
      // console.log(this.subdomainpassedfromrefined);
      this.keywordholder.autoname = this.subdomainpassedfromrefined.kwautoname;
      this.keywordholder.name = this.subdomainpassedfromrefined.kw;
      this.keywordholder.domain = this.subdomainpassedfromrefined.kwdomain;
      this.keywordholder.subdomain = this.subdomainpassedfromrefined.kwsubdomain;
      this.keywordholder.typ = this.subdomainpassedfromrefined.kwtyp;
      this.kw_autoname = this.keywordholder.autoname;

    }
    if (this.searchfields.sortfield) {
      this.sortfield = this.searchfields.sortfield;
    }
    if (this.searchfields.sortorder) {
      this.sortorder = this.searchfields.sortorder;
    }
  }
  /* clickedoutsider(e) {
     console.log('clicked outside', e);
     const targetid = e.target.id;
     if (targetid !== undefined) {
       if (targetid !== 'morefiltericon') {
        // this.closeMoreoptions();
       }
     }
   }*/
  closeMoreoptions() {
    // this.passedRefine = [];
    this.showmoreoptionsSec = false;
    this.showMoreOptionsOverlay = false;
  }
  showMoreOptions() {
    if (this.showmoreoptionsSec) {
      this.showmoreoptionsSec = false;
      this.showMoreOptionsOverlay = false;
    } else {
      this.showmoreoptionsSec = true;
      this.showMoreOptionsOverlay = true;
    }

    /*const dialogRef = this.dialog.open(SearchMoreOptionsComponent, {
      width: '50%',
      panelClass: 'moreoptionsmainclass',
      data: {
        type : 'add'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.length > 0) { // custom filter selected from more options page
          this.moreoptions_arr = result;
          // console.log('moreoption returned', this.moreoptions_arr);
          this.do_search('');
        }
    }
    });*/
  }
  isNameExists(name) {
    const found = this.holdisplaylist['label'].some(function (el) {
      return el.autoname === name;
    });
    if (!found) {
      return false;
    }
    return true;
  }
  handleNormalSearchClick() {
    // console.log(this.holdisplaylist['label']);
    // this.moreoptions_arr = [];
    // this.showmoreoptionsSec = false;
    // if (!this.kw_autoname || this.kw_autoname.trim() === '') {
    //   this.do_search(null, true);
    // } else if (this.holdisplaylist['label'].length !== 0) {
    //     if (!this.isNameExists(this.kw_autoname)) {
    //       this.do_search();
    //     } else {
    //       this.setKeyword(this.holdisplaylist['label'][0]);
    //     }
    // } else {
    //   this.do_search();
    // }
    this.acc_selected = this.acc_name;
    // console.log(this.acc_name)
    this.claimable_selected = this.selected_claimable;
    console.log('cliamble value................' + this.claimable_selected);
    this.do_search();
  } 
 
  handleSearchmoreSearchClick(result) {
    // console.log('more returned', result);
    this.moreoptions_arr = result;
    this.showmoreoptionsSec = false;
    // console.log('moreoption returned', this.moreoptions_arr);
    this.do_search('', true);
  }

  // method with decides whether the more option link is to be display
  chk_moreoptionshow() {
    if ((this.selected_domain !== '' && this.selected_domain !== undefined
      && this.selected_domain !== 'undefined' && this.selected_domain !== 'All')
      || (this.keywordholder.name !== '') || (this.locationholder.name !== '' && this.locationholder.name !== null)) {
      const currenturl = this.routerobj.url.split(';');
      if (currenturl[0] !== '/searchdetail') {
        return true;
      }
    }
  }
  // loads the location details in json file to the respective array
  private loadLocationjsontoArray() {
    for (const state of locationjson['states']) {
      const objstate = { autoname: state.name + ', India', name: state.name, lat: state.latitude,
       lon: state.longitude, typ: 'state', rank: 4 };
      this.locationList.push(objstate);
      for (const city of state.cities) {
        const objcity = { autoname: city.name + ', ' + state.name, name: city.name, lat: city.latitude, 
        lon: city.longitude, typ: 'city', rank: 3 };
        this.locationList.push(objcity);
        for (const area of city.locations) {
          const objarea = { autoname: area.name + ', ' + city.name + ', ' + state.name, name: area.name,
           lat: area.latitude, lon: area.longitude, typ: 'area', rank: 5 };
          this.locationList.push(objarea);
        }
      }
    }
    for (const metro of metrojson['metros']) {
      const objstate = { autoname: metro.name + ' (Metro)', name: metro.name, 
      lat: metro.latitude, lon: metro.longitude, typ: 'metro', rank: 1 };
      this.locationList.push(objstate);
    }
    for (const capital of metrojson['capitals']) {
      const objstate = { autoname: capital.name + ' (Capital)', name: capital.name,
       lat: capital.latitude, lon: capital.longitude, typ: 'capital', rank: 2 };
      this.locationList.push(objstate);
    }
    this.locationList.sort((a, b) => a.rank.toString().localeCompare(b.rank.toString()));
    //  console.log(this.locationList);
  }
  private filterLocation(criteria: string = '') {
    this.locsearchcriteria = criteria;
    this.displaylocationList = [];
    const maxcnt = projectConstants.AUTOSUGGEST_LOC_MAX_CNT;
    let curcnt = 1;
    if (criteria === '') {
      this.setNulllocationvalues('');
      console.log('serachFileds' + this.searchfields);
      this.searchfields.location = '';
      this.searchfields.locationautoname = '';
      this.searchfields.locationtype = '';
      this.searchfields.latitude = undefined;
      this.searchfields.longitude = undefined;
    } else {
      if (criteria.length >= projectConstants.AUTOSUGGEST_MIN_CHAR) {
        const hold_criteria = criteria.toLowerCase();
        for (const locs of this.locationList) {
          const holdlocname = locs.autoname.toLowerCase();
          if (holdlocname.startsWith(hold_criteria)) {
            // if (holdlocname.includes(hold_criteria)) {
            if (curcnt <= maxcnt) {
              this.displaylocationList.push(locs);
            }
            curcnt++;
          }
        }
      }
    }
  }
  // loads the keyword details to the respective arrays
  private loadkeywordAPIreponsetoArray() {
    this.displaykeywordList = [];
    this.keywordList = [];
    // Initialize the arrays
    this.subdomainList = [];
    this.specilizationList = [];
    this.keyssearchcriteria = '';

    if (!this.domainlist_data) {
      return;
    }
    // get the list of subdomains and specializations to the respective arrays
    const domain = this.selected_domain || '';
    for (const dom of this.domainlist_data) {
      let getsubdomainandspec = true;
      if (domain !== '' && domain !== 'All') {
        if (domain !== dom.domain) {
          getsubdomainandspec = false;
        }
      }
      if (getsubdomainandspec === true) {
        for (const subdom of dom.subDomains) {
          const keywordsub = { autoname: subdom.displayName, name: subdom.subDomain, subdomain: '', domain: dom.domain,
          typ: 'subdom', claimable: '' , title: ''};
          this.subdomainList.push(keywordsub);
          for (const special of subdom.specializations) {
            const keywordspec = { autoname: special.displayName, name: special.name,
              subdomain: subdom.subDomain, domain: dom.domain, typ: 'special', claimable: this.claimable_selected , title: this.acc_selected};
            this.specilizationList.push(keywordspec);
          }
        }
      }
    }
    this.keywordList = [];
    // Call method to merge the subdomain details to the keyword array
    //  this.addheadandMergearray('subdom');
    // Call method to merge the specialization details to the keyword array
    //  this.addheadandMergearray('special');
  }
  private addheadandMergearray(typ) {
    switch (typ) {
      case 'subdom':
        if (this.subdomainList.length > 0) {
          const holderarr = this.keywordList.concat(this.subdomainList);
          this.keywordList = holderarr;
        }
        break;
      case 'special':
        if (this.specilizationList.length > 0) {
          const holderarr = this.keywordList.concat(this.specilizationList);
          this.keywordList = holderarr;
        }
        break;
    }
  }
  filterKeywords(criteria: string = '') {
     console.log('Criteria:' + criteria);
    this.keyssearchcriteria = criteria.toLowerCase();
    this.displaykeywordList = [];
    this.keywordgroupList = [];
    this.holdisplaylist = [];
    if (criteria === '') {
      //  this.displaykeywordList = [];
      this.setNullKeyword('');

      this.searchfields.kw = '';
      this.searchfields.kwautoname = '';
      this.searchfields.kwdomain = '';
      this.searchfields.kwsubdomain = '';
      this.searchfields.kwtyp = '';

    } else {

      // if (criteria.length >= projectConstants.AUTOSUGGEST_MIN_CHAR) {
      //    const hold_criteria = criteria.toLowerCase();
      // let curcnt = 1;
      //  this.displaykeywordList.push({autoname: criteria, name: criteria, domain: '', subdomain: '', typ: 'kwtitle'});
      // for (const kw of this.keywordList) {
      //   const holdkeyword = kw.autoname.toLowerCase();
      //    if (holdkeyword.includes(hold_criteria)) {
      // if (curcnt <= projectConstants.AUTOSUGGEST_LOC_MAX_CNT) {
      // this.displaykeywordList.push(kw);
      // curcnt++;
      // }
      //   }
      // }

      // this.holdisplaylist['subdom'] = new Array();
      // this.holdisplaylist['special'] = new Array();
      this.holdisplaylist['kwtitle'] = new Array();
      if (criteria.length >= projectConstants.AUTOSUGGEST_MIN_CHAR) {
        const hold_criteria = criteria.toLowerCase();
        this.holdisplaylist['kwtitle'].push({ autoname: criteria, name: criteria, domain: '', subdomain: '', typ: 'kwtitle' });
      }
      // for (const kw of this.displaykeywordList) {

      //   if (kw.typ === 'kwtitle') {
      //     this.holdisplaylist['kwtitle'].push(kw);
      //   }
      //   // case of subdomain header row
      //   if (kw.typ === 'subdom') {
      //     this.holdisplaylist['subdom'].push(kw);
      //   }

      //    // case of specialization header row
      //   if (kw.typ === 'special') {
      //     this.holdisplaylist['special'].push(kw);
      //   }
      // }
      //  }
    }

    // Defining the types of details that will be displayed for keywords autocomplete
    const keywordgroup_val = [];

    // Check whether the title is to be displayed
    // if (this.holdisplaylist['kwtitle']) {
    //   if (this.holdisplaylist['kwtitle'].length > 0) {
    //     const groupdomainobj = {displayname: 'Business Name/Keyword', name: 'kwtitle'};
    //     keywordgroup_val.push(groupdomainobj);
    //   }
    // }
    // Check whether the subdomain heading is to be displayed
    // if (this.holdisplaylist['subdom']) {
    //   if (this.holdisplaylist['subdom'].length > 0) {
    //     const groupdomainobj = {displayname: '', name: 'subdom'};
    //     keywordgroup_val.push(groupdomainobj);
    //   }
    // }
    // Check whether the specialization heading is to be displayed
    // if (this.holdisplaylist['special']) {
    //   if (this.holdisplaylist['special'].length > 0) {
    //     const groupspecialobj = {displayname: 'Specializations', name: 'special'};
    //     keywordgroup_val.push(groupspecialobj);
    //   }
    // }
    // Check whether search labels exists
    if (this.show_searchlabellist) {
      this.holdisplaylist['label'] = [];
      this.holdisplaylist['special'] = [];
      for (const label of this.show_searchlabellist) {
        const holdkeyword = label.displayname.toLowerCase();
        // const holdkeyword = label.displayname.toLowerCase();
        if (label.displayname !== '') {
          if (holdkeyword.includes(this.keyssearchcriteria)) {
            const lbl = label.query.split('&');
            // console.log(label.type);
            if (label.type === 'special') {
              const labelspec = { autoname: label.displayname, name: label.name,
                 subdomain: '', domain: this.shared_functions.Lbase64Encode(lbl[0]), typ: label.type };
              this.holdisplaylist['special'].push(labelspec);
            } else {
              const labelspec = { autoname: label.displayname, name: label.name, 
                subdomain: '', domain: this.shared_functions.Lbase64Encode(lbl[0]), typ: 'label' };
              this.holdisplaylist['label'].push(labelspec);
            }
          }
        }
        // console.log(this.holdisplaylist);
      }
      // Check whether search labels heading is to be displayed
      if (this.holdisplaylist['kwtitle']) {
        if (this.holdisplaylist['kwtitle'].length > 0) {
          const groupdomainobj = { displayname: 'Business Name/Keyword', name: 'kwtitle' };
          keywordgroup_val.push(groupdomainobj);
        }
      }
      if (this.holdisplaylist['label'].length > 0) {
        const grouplabelsobj = { displayname: 'Suggested Searches', name: 'label' };
        keywordgroup_val.push(grouplabelsobj);
      }
      if (this.holdisplaylist['special'].length > 0) {
        const grouplabelsobj = { displayname: 'Specialization', name: 'special' };
        keywordgroup_val.push(grouplabelsobj);
      }
    }
    this.keywordgroupList = keywordgroup_val;
    // assiging the details to the displayed in the autosuggestion for keywords box
    this.displaykeywordList = this.holdisplaylist;
    // console.log('Display Search Items');
    // console.log(this.displaykeywordList);
  }
  // this method decides how the items are shown in the autosuggestion list
  highlightSelText(curtext, classname, mod?, typ?) {
    let criteria = '';
    switch (mod) {
      case 'keyword':
        criteria = this.keyssearchcriteria;
        break;
      case 'location':
        criteria = this.locsearchcriteria;
        break;
    }
    const regexp = new RegExp(criteria, 'gi');
    if (criteria !== '' && criteria.length >= projectConstants.AUTOSUGGEST_MIN_CHAR) {
      // convert the criteria and current text to lower case to find the position of criteria in the string
      const l_criteria = criteria.toLowerCase();
      const l_curtext = curtext.toLowerCase();
      const index = l_curtext.indexOf(l_criteria);
      const foundstr = curtext.substr(index, criteria.length);
      return curtext.replace(regexp, '<span class="' + classname + '">' + foundstr + '</span>');
    } else {
      return curtext;
    }
  }

  private initialize_fields() {
     console.log('initialize', this.searchfields);
    if (this.searchfields.domain) {
      this.selected_domain = this.searchfields.domain;
    }
    if (this.passedDomain !== undefined && this.passedDomain !== '') { // case if domain details passed to this component via input variable
      this.selected_domain = this.passedDomain;
    }
    if (this.searchfields.sortfield) {
      this.sortfield = this.searchfields.sortfield;
    }
    if (this.searchfields.sortorder) {
      this.sortorder = this.searchfields.sortorder;
    }
    if (this.searchfields.location) { // set the location related fields to the respective holders
      this.location_name = this.searchfields.locationautoname;
      this.locationholder.autoname = this.searchfields.locationautoname;
      this.locationholder.typ = this.searchfields.locationtype;
      this.locationholder.name = this.searchfields.location;
      this.locationholder.lat = this.searchfields.latitude;
      this.locationholder.lon = this.searchfields.longitude;
    }
    if (this.searchfields.kw) { // set the keyword related fields to the respective holders
      this.kw_autoname = this.searchfields.kwautoname;
      this.keywordholder.autoname = this.searchfields.kwautoname;
      this.keywordholder.name = this.searchfields.kw;
      this.keywordholder.domain = this.searchfields.kwdomain;
      this.keywordholder.subdomain = this.searchfields.kwsubdomain;
      this.keywordholder.typ = this.searchfields.kwtyp;
      this.keywordholder.claimable = this.searchfields.kwclaimable;
       this.keywordholder.title = this.searchfields.acccname;
    }

    if (this.passedkwdet && this.passedkwdet.kw !== undefined) { // case if kw details passed to this component via input variable
      this.kw_autoname = this.passedkwdet.kwautoname;
      this.keywordholder.autoname = this.passedkwdet.kwautoname;
      this.keywordholder.name = this.passedkwdet.kw;
      this.keywordholder.domain = this.passedkwdet.kwdomain;
      this.keywordholder.subdomain = this.passedkwdet.kwsubdomain;
      this.keywordholder.typ = this.passedkwdet.kwtyp;
    }
    if (this.searchfields.commonfilters) {
      this.commonfilters = this.searchfields.commonfilters;
    }
  }
  /*private getDomainList() {
    this.shared_service.bussinessDomains()
    .subscribe (
      res => {
         this.domainlist_data = res;
         this.loadkeywordAPIreponsetoArray();
      }
    );
  }*/

  getDomainList() {
    const bconfig = this.shared_functions.getitemfromLocalStorage('ynw-bconf');
    let run_api = true;
    if (bconfig) {
      if (bconfig.bdata) { // case if data is there in local storage
        const bdate = bconfig.cdate;
        const bdata = bconfig.bdata;
        const saveddate = new Date(bdate);
        const diff = this.shared_functions.getdaysdifffromDates('now', saveddate);
        // console.log('diff hours search', diff['hours']);
        if (diff['hours'] < projectConstants.DOMAINLIST_APIFETCH_HOURS) {
          run_api = false;
          this.domainlist_data = bdata;
          // this.loadkeywordAPIreponsetoArray();
        }
      }
    }
    if (run_api) { // case if data is not there in data
      this.shared_service.bussinessDomains()
        .subscribe(
          res => {
            this.domainlist_data = res;
            //  this.loadkeywordAPIreponsetoArray();
            const today = new Date();
            const postdata = {
              cdate: today,
              bdata: this.domainlist_data
            };
            this.shared_functions.setitemonLocalStorage('ynw-bconf', postdata);
          }
        );
    }
  }

  getAllsearchlabels() {
    // check whether search labels exists in local storage
    const srchlabels = this.shared_functions.getitemfromLocalStorage('srchLabels');
    if (srchlabels) {
      this.searchlabels_data = srchlabels || [];
      this.searchdataserviceobj.set(this.searchlabels_data);
      this.handledomainchange(this.selected_domain, 1);
    } else {
      this.shared_service.getAllSearchlabels()
        .subscribe(
          res => {
            this.searchlabels_data = res || [];
            this.shared_functions.setitemonLocalStorage('srchLabels', res);
            this.searchdataserviceobj.set(this.searchlabels_data);
            this.handledomainchange(this.selected_domain, 1);
          }
        );
    }
  }
  /*private do_domain_sel(domainname) {
     this.selected_domain = domainname;
   }
   /*private getLocation(criteria) {
     this.location_exists = false;
     this.nocriteria = true;
     this.loading = true;
     this.location_latitude = undefined;
     this.location_longitude = undefined;
     this.hide_location_div = false;
       if (criteria !== '') {
         if ( this.subscription ) {
             this.subscription.unsubscribe();
           }

         // Creating criteria to be passed via get
         const pass_criteria = {
           'criteria': criteria
         };
         this.subscription = this.shared_service.GetsearchLocation(pass_criteria)
           .subscribe(res => {
             this.location_data = res;
             if (!res[0]) { this.setNulllocationvalues(res); } this.loading = false;
           });
         } else {
         if ( this.subscription ) {
           this.subscription.unsubscribe();
         }
         this.loading = false;
         this.location_data = undefined;
       }
   }*/
  private setLocation(loc) {
    this.locationholder = {
      name: loc.name,
      autoname: loc.autoname,
      lat: loc.lat,
      lon: loc.lon,
      typ: loc.typ,
      rank: loc.rank
    };
    this.shared_functions.setitemonLocalStorage('ynw-locdet', this.locationholder);
    this.location_data = undefined;
    // console.log('loc', loc);
  }
  private setNulllocationvalues(loc?) {
    this.locationholder = {
      name: loc.name || null,
      autoname: loc.autoname || null,
      lat: loc.lat || null,
      lon: loc.lon || null,
      typ: loc.typ || null,
      rank: loc.rank || null
    };
    this.location_data = undefined;
  }
  private hideLocation() {
    this.hide_location_div = true;
  }

  private setKeyword(kw) {
    if (kw.name !== '') {
      this.kw_autoname = kw.autoname;
      this.keywordholder = {
        autoname: kw.autoname,
        name: kw.name,
        domain: kw.domain,
        subdomain: kw.subdomain,
        typ: kw.typ,
        claimable: kw.claimable,
        title: kw.title
      };
    }
    // console.log('kwholder', this.keywordholder);
    if (kw.typ === 'label') {
      this.curlabel.typ = 'label';
      this.curlabel.query = kw.domain;
      const passkw = { query: kw.domain }; // kw.domain holds the hardcoded query for the search labels
      if (kw.domain !== '') {
        this.searchlabels_clicked(passkw);
      }
    } else {
      this.curlabel.typ = '';
      this.curlabel.query = '';
    }
    if (kw.typ !== 'label') { // execute search when selected an option using mouse in keyword box
      this.do_search();
    }
  }
  private setNullKeyword(kw?) {
    this.keywordholder = {
      autoname: kw.autoname || '',
      name: kw.name || '',
      domain: kw.domain || '',
      subdomain: kw.subdomain || '',
      typ: kw.typ || '',
      claimable: kw.claimable || '',
      title: kw.title || ''
    };
    // console.log(kw.title);
  }
  kwtyping(ev, val) {
    const kCode = parseInt(ev.keyCode, 10);
    switch (kCode) {
      case 37: // left arrow key
      case 38: // top arrow key
      case 39: // right arrow key
      case 40: // bottom arrow key
        // do nothing for above keys
        break;
      case 13: // enter key
        // this.provRef.nativeElement.closePanel();
        // this.provRef.closePanel();
        this.provRef.closePanel();
        this.setKeyword(this.keywordholder);
        break;
      default: // if other than above keys, then by default set the type as 'kwtitle'
        this.kw_autoname = val;
        this.keywordholder.name = val;
        this.keywordholder.autoname = val;
        this.keywordholder.domain = '';
        this.keywordholder.subdomain = '';
        // this.keywordholder.typ = 'kwtitle';
        this.keywordholder.typ = 'kwphrase';
        this.curlabel.typ = '';
        this.curlabel.query = '';
        // console.log('reached here', this.keywordholder);
        break;
    }
  }
  selectedOption(kw) {
    // console.log('selected', kw);
  }
  do_search(labelqpassed?, buttonclick?) {
    // console.log('buttonclick', buttonclick);
    this.shared_functions.setitemonLocalStorage('ynw_srchb', 1);
    this.closeMoreoptions();
    // console.log('search clicked');

    // done to handle the case if something is typed in the last text box and nothing else is selected by consumer, but some text is there
    // in such as case the text will be used to search against the index 'title'
    // console.log('kwauto', this.kw_autoname);
    if (this.kw_autoname !== '' && this.kw_autoname !== undefined) {
      if (this.keywordholder.typ === '' || this.keywordholder.typ === undefined || this.keywordholder.typ === 'kwtitle') {
        this.keywordholder.name = this.kw_autoname;
        this.keywordholder.autoname = this.kw_autoname;
        this.keywordholder.domain = '';
        this.keywordholder.subdomain = '';
        this.keywordholder.typ = 'kwtitle';
      }
    }

    let labelq = labelqpassed;
    if (labelq === '' || labelq === undefined) {
      if (this.curlabel.typ === 'label') {
        if (this.curlabel.query !== '') {
          labelq = this.curlabel.query;
        }
      }
    }
    const currenturl = this.routerobj.url.split(';');

    /* if (!this.location_latitude) {
       this.location_name = '';
     }*/

    // Checking whether the location is blank, if yes, then set it to the default location mentioned in the constants file
    this.checktoSetLocationtoDefaultLocation();

    if (currenturl[0] === '/searchdetail') { // if clicked search button from the search result page itself
      this.onsearchclick(labelq);
      // window.location.reload();
    } else { // clicked search button from home page

      /*this.routerobj.navigate(['/searchdetail'], { queryParams: { do: this.selected_domain, la: this.location_latitude,
          lo: this.location_longitude, prov: this.prov_name, lon: this.location_name,
          srt: this.sortfield + ' ' + this.sortorder, ps: this.searchlabel_search, on: this.opennow_search,
        lq: labelq }}); */

      const passparam = {
        do: this.selected_domain || '',
        la: this.locationholder.lat || '',
        lo: this.locationholder.lon || '',
        lon: this.locationholder.name || '',
        lontyp: this.locationholder.typ || '',
        lonauto: this.locationholder.autoname || '',
        kw: this.keywordholder.name || '',
        kwauto: this.keywordholder.autoname || '',
        kwdomain: this.keywordholder.domain || '',
        kwsubdomain: this.keywordholder.subdomain || '',
        kwclaimable: this.claimable_selected || '',
        acccname: this.acc_selected || '',
        kwtyp: this.keywordholder.typ || '',
        srt: this.sortfield + ' ' + this.sortorder,
        lq: labelq || '',
        cfilter: this.commonfilters || ''
      };
      console.log(this.acc_name);
      if (this.moreoptions_arr.length > 0) {
        for (let i = 0; i < this.moreoptions_arr.length; i++) {
          for (const field in this.moreoptions_arr[i]) {
            if (field) {
              // console.log('field', field, this.moreoptions_arr[i][field]);
              let valstr = '';
              for (const fval of this.moreoptions_arr[i][field]) {
                if (valstr !== '') {
                  valstr += '~';
                }
                valstr += fval[0];
              }
              passparam['myref_' + field.toString()] = valstr;
            }
          }
        }
      }
       console.log('params', passparam);
      this.routerobj.navigate(['searchdetail', passparam], { relativeTo: this.route });
    }
  }
  private opennow_searchhandle() {
    this.opennow_search = 1;
    this.do_search();

  }
  onsearchclick(labelq?) {

    this.searchfields.domain = this.selected_domain;
    if (this.locationholder.name === '') {
      this.locationholder.lat = undefined;
      this.locationholder.lon = undefined;
      this.locationholder.typ = '';
      this.searchfields.location = '';
      this.searchfields.locationautoname = '';
      this.searchfields.locationtype = '';
      this.searchfields.latitude = undefined;
      this.searchfields.longitude = undefined;
    } else {
      // this.location_name = this.locationholder.autoname;

      if (this.locRef.nativeElement) {
        this.locRef.nativeElement.value = this.locationholder.autoname;
      }
      // console.log('locauto', this.locationholder.autoname);
      this.searchfields.location = this.locationholder.name;
      this.searchfields.locationautoname = this.locationholder.autoname;
      this.searchfields.locationtype = this.locationholder.typ;
      this.searchfields.latitude = this.locationholder.lat;
      this.searchfields.longitude = this.locationholder.lon;
    }

    if (this.kw_autoname === '') {
      // console.log('reset here');
      this.keywordholder.name = '';
      this.keywordholder.autoname = '';
      this.keywordholder.domain = '';
      this.keywordholder.subdomain = '';
      this.keywordholder.typ = '';
    }
    // console.log('holder', this.keywordholder);
    this.searchfields.kw = this.keywordholder.name;
    this.searchfields.kwautoname = this.keywordholder.autoname;
    this.searchfields.kwdomain = this.keywordholder.domain;
    this.searchfields.kwsubdomain = this.keywordholder.subdomain;
    this.searchfields.kwtyp = this.keywordholder.typ;
    this.searchfields.commonfilters = this.commonfilters;

    if (labelq !== '' && labelq !== undefined && labelq !== 'undefined') {
      if (this.keywordholder.typ === 'label') {
        this.searchfields.kwdomain = '';
        this.searchfields.kwtyp = '';
      }
    }

    if (labelq === '' || labelq === undefined || labelq === 'undefined') {
      // console.log('holder', this.keywordholder);
      this.searchfields.kwdomain = '';
      // this.searchfields.kwtyp = this.keywordholder.typ;
    }

    // this.searchfields.provider = this.prov_name;
    this.searchfields.sortfield = this.sortfield;
    this.searchfields.sortorder = this.sortorder;
    this.searchfields.labelq = labelq || '';
    // if (this.searchfields.labelq != '') {
    if (labelq !== '' && labelq !== undefined && labelq !== 'undefined') {
      const ret_arr = this.parsesearchLabelsQuerystring(this.searchfields.labelq);
      // console.log('label return', ret_arr);
      if (ret_arr['sector'] !== '') {
        this.searchfields.domain = ret_arr['sector'];
        this.selected_domain = this.searchfields.domain;
      }
      if (ret_arr['subsector'] !== '') {
        const ret = this.getdomainofaSubdomain(ret_arr['subsector']);
        ret_arr['subdom_dispname'] = ret['subdom_dispname'] || ret_arr['subsector'];
        if (ret_arr['sector'] === '') { // sector not mentioned in the search label condition
          if (ret['dom'] === '') {
            ret.dom = 'All';
          }
          ret_arr['dom'] = ret['dom'];
          this.searchfields.domain = ret['dom'];
          // console.log('retdom', ret);
        }
        this.searchfields.subsector = ret_arr['subsector'];
        this.searchfields.kw = ret_arr['subsector'];
        this.searchfields.kwautoname = ret_arr['subdom_dispname'];
        this.searchfields.kwdomain = ret_arr['dom'];
        this.searchfields.kwsubdomain = '';
        this.searchfields.kwtyp = 'subdom';
        this.selected_domain = this.searchfields.domain;
        // this.kw_autoname = this.searchfields.kw;
        this.kw_autoname = ret_arr['subdom_dispname'];
      }
    }
    if (this.moreoptions_arr.length > 0) {
      this.searchfields.passrefinedfilters = this.moreoptions_arr;
    } else {
      this.searchfields.passrefinedfilters = [];
    }
    // console.log('emitted fields', this.searchfields);
    this.searchclick.emit(this.searchfields);
  }
  getdomainofaSubdomain(subdomname) {
    let retarr = { 'dom': '', 'subdom_dispname': '' };
    if (this.domainlist_data) {
      for (let i = 0; i < this.domainlist_data.length; i++) {
        for (const subdom of this.domainlist_data[i].subDomains) {
          if (subdom.subDomain === subdomname) {
            retarr = { 'dom': this.domainlist_data[i].domain, 'subdom_dispname': subdom.displayName };
            return retarr;
          }
        }
      }
    }
    return retarr;
  }
  getdomainofaSpecialization(specialization) {
    //  console.log('domain list', this.domainlist_data);
    let retarr = { 'dom': '', 'special_dispname': '' };
    if (this.domainlist_data) {
      for (let i = 0; i < this.domainlist_data.length; i++) {
        for (const subdom of this.domainlist_data[i].subDomains) {
          for (const specilization of subdom.specializations) {
            if (specilization.name === specialization) {
              retarr = { 'dom': this.domainlist_data[i].domain, 'special_dispname': specilization.displayName };
              return retarr;
            }
          }
        }
      }
    } // else {
    retarr = { 'dom': '', 'special_dispname': '' };
    return retarr;
    // }
  }
  // function which parse the querystring from search leabels
  parsesearchLabelsQuerystring(str = null) {
    const retarr = {
      'sector': '',
      'subsector': '',
      'specialization': '',
      'rating': '',
      'title': ''
    };
    // console.log('str', str);
    if (str !== null) {
      if (str.match(/\ssector:'(.*?)'/) !== null) {
        retarr['sector'] = str.match(/\ssector:'(.*?)'/)[1];
      }
      if (str.match(/sub_sector:'(.*?)'/) !== null) {
        retarr['subsector'] = str.match(/sub_sector:'(.*?)'/)[1];
      }
      if (str.match(/specialization:'(.*?)'/) !== null) {
        retarr['specialization'] = str.match(/specialization:'(.*?)'/)[1];
      }
      if (str.match(/title:'(.*?)'/) !== null) {
        retarr['title'] = str.match(/title:'(.*?)'/)[1];
      }
      return retarr;
    }
  }

  handledomainchange(domain, avoidclear?) {
    // setting the domain in the selected_domain holder variable
    // alert('here' + this.selected_domain);
    if (domain === 'All') {
      // domain = '';
    }
    this.selected_domain = domain;
    if (avoidclear === 1) {
    } else {
      this.kw_autoname = '';
      this.keywordholder = {
        autoname: '',
        name: '',
        domain: '',
        subdomain: '',
        typ: '',
        claimable : '',
        title : ''
      };
      this.curlabel = { typ: '', query: '' };
    }
    this.keyssearchcriteria = '';
    this.prov_name = '';
    // alert(this.selected_domain);
  //  this.getSearchlabelsbydomain(domain);
    // this.loadkeywordAPIreponsetoArray();
    if (avoidclear === undefined) {
     // this.handleNormalSearchClick();
    }
    // this.handleNormalSearchClick();
  }
  handleclaimablechange(claimable_value) {
   this.claimable_selected = claimable_value;
  // this.handleNormalSearchClick();

  }
  getSearchlabelsbydomain(domain) {
    if (domain == null || domain === '' || domain === 'All') {
      this.show_searchlabellist = this.shared_functions.get_Searchlabels('global', this.searchdataserviceobj.getAll());
    } else {
      this.show_searchlabellist = this.shared_functions.get_Searchlabels('domain', this.searchdataserviceobj.getAll(),
       { 'domain': domain });
    }
  }
  searchlabels_clicked(obj) {
    this.setNulllocationvalues('');
    // this.setNullKeyword('');
    this.do_search(obj.query);
  }
  handleCustomfilter(val) {
    this.commonfilters = val;
    this.do_search();
  }
  handle_returntochild(obj) {
    // console.log('reached back');
  }
  clearSearch(obj) {
    this.displaylocationList = [];
    obj.value = '';
  }
  blurSearch(obj) {
    /* if (this.holdsrchlocname !== '' && obj.value === '') {
       obj.value = this.holdsrchlocname;
     }*/
    if (obj.value === '') {
      obj.value = this.locationholder.autoname;
    }
  }
  deselect() {
    // console.log('blur');
    if (this.locRef.nativeElement) {
      this.locRef.nativeElement.value = this.locRef.nativeElement.value;
    }
  }
}


